enum DynamicGeofencesProfile {
  Driving = 'driving',
  Walking = 'walking',
  Cycling = 'cycling',
}

export default DynamicGeofencesProfile;
